interface Sentence {
  original: string;
  french: string;
  // English translation of `french`, optional; falls back to `french` when absent.
  english?: string;
  words: string[];
  audio?: string;
  category: string;
  tags: string[];
}

export const SENTENCE_CATEGORIES = {
  'Salutations': {
    icon: '👋',
    description: 'Premiers contacts et formules de politesse',
  },
  'Présentation': {
    icon: '🤝',
    description: 'Se présenter et faire connaissance',
  },
  'Vie quotidienne': {
    icon: '🌞',
    description: 'Expressions du quotidien',
  },
  'Au marché': {
    icon: '🛍️',
    description: 'Faire ses courses et négocier',
  },
  'Voyages': {
    icon: '✈️',
    description: 'Se déplacer et visiter',
  },
  'Famille et relations': {
    icon: '👨‍👩‍👧‍👦',
    description: 'Parler de sa famille et de ses proches',
  },
  'Urgences et santé': {
    icon: '🏥',
    description: 'Expressions pour les situations médicales et urgentes',
  },
  'Loisirs et culture': {
    icon: '🎭',
    description: 'Parler de ses activités, passe-temps et culture',
  }
} as const;

export const sentencesToConstruct: Sentence[] = [
  // ==========================================
  // SALUTATIONS - PHRASES COMPLÈTES
  // ==========================================
  
  {
    original: "Mbote na bino baninga",
    french: "Bonjour à vous les amis",
    english: "Hello to you, my friends",
    words: ["Mbote", "na", "bino", "baninga"],
    audio: "Li-Mbote_na_bino_baninga",
    category: 'Salutations',
    tags: ['salutations', 'groupe', 'amitié']
  },
   {
    original: "Nsango nini ? ",
    french: "Comment ça va ?",
    english: "How's it going?",
    words: ["Nsango", "nini", "?"],
    audio: "Li-Nsango_nini",
    category: 'Salutations',
    tags: ['salutations', 'groupe', 'amitié']
  },

  {
    original: "Nazali na mbula tuku mibale na mibale",
    french: "J'ai 22 ans",
    english: "I am 22 years old",
    words: ["Nazali", "na", "mbula", "tuku","mibale","na","mibale"],
    audio: "Li-Nazali_na_mbula_tuku_mibale_na_mibale",
    category: 'Salutations',
    tags: ['salutations', 'groupe', 'amitié']
  },

  {
    original: "Nkombo na ngai Nzola",
    french: "Je m'appelle Nzola",
    english: "My name is Nzola",
    words: ["Nkombo", "na", "ngai", "Nzola"],
    audio: "Li-Nkombo_na_ngai_nzola",
    category: 'Salutations',
    tags: ['salutations', 'groupe', 'amitié']
  },

   {
    original: "Okola wapi ?",
    french: "Où as tu grandi ?",
    english: "Where did you grow up?",
    words: ["Okola", "wapi", "?"],
    audio: "Li-Okola_wapi",
    category: 'Salutations',
    tags: ['salutations', 'groupe', 'amitié']
  },


 

  {
    original: "Nabotama na France te kasi nakola awa ?",
    french: "Je ne suis pas née en France mais j'ai grandi ici ?",
    english: "I wasn't born in France, but I grew up here",
    words: ["Nabotama", "na", "France","te","kasi","nakola","awa","?"],
    audio: "Li-Nabotama_na_france_te_kasi_nakola_awa",
    category: 'Salutations',
    tags: ['salutations', 'groupe', 'amitié']
  },

   {
    original: "Owuti mboka nini ? ",
    french: "De quel pays viens-tu ?",
    english: "What country are you from?",
    words: ["Owuti", "mboka", "nini","?"],
    audio: "Li-Owuti_mboka_nini",
    category: 'Salutations',
    tags: ['salutations', 'groupe', 'amitié']
  },


  {
    original: "Nafandaka na sima ya Tour Eiffel ",
    french: "J'habite derrière la Tour Eiffel",
    english: "I live behind the Eiffel Tower",
    words: ["Nafandaka", "na", "sima","ya","Tour","Eiffel"],
    audio: "Li-Nafandaka_na_sima_ya_tour_eiffel",
    category: 'Salutations',
    tags: ['salutations', 'groupe', 'amitié']
  },

    {
    original: "Sima mikolo zomi naye France ",
    french: "Dix jours après je suis venu en France",
    english: "Ten days later I came to France",
    words: ["Sima", "mikolo", "zomi","naye","France"],
    audio: "Li-Sima_mikolo_zomi_naye_france",
    category: 'Salutations',
    tags: ['salutations', 'groupe', 'amitié']
  },



   {
    original: "Nawuti Dakar ",
    french: "Je viens de Dakar",
    english: "I come from Dakar",
    words: ["Nawuti", "Dakar"],
    audio: "Li-Nawuti_dakar",
    category: 'Salutations',
    tags: ['salutations', 'groupe', 'amitié']
  },

  {
    original: "Ofandaka wapi ?",
    french: "Ou habites-tu ?",
    english: "Where do you live?",
    words: ["Ofandaka", "wapi","?"],
    audio: "Li-Ofandaka_wapi",
    category: 'Salutations',
    tags: ['salutations', 'groupe', 'amitié']
  },

  
  {
    original: "Ozali mutu ya ekolo nini ?",
    french: "De quelle ethnie es-tu ?",
    english: "What ethnicity are you?",
    words: ["Ozali", "mutu","ya","ekolo","nini","?"],
    audio: "Li-Ozali_mutu_ya_ekolo_nini",
    category: 'Salutations',
    tags: ['salutations', 'groupe', 'amitié']
  },

   
  {
    original: "Nazali Muluba",
    french: "Je suis Muluba",
    english: "I am Muluba",
    words: ["Nazali", "Muluba"],
    audio: "Li-Nazali_muluba",
    category: 'Salutations',
    tags: ['salutations', 'groupe', 'amitié']
  },


   {
    original: "Nakola na Paris",
    french: "J'ai grandi à Paris",
    english: "I grew up in Paris",
    words: ["Nakola", "na", "Paris"],
    audio: "Li-Nakola_na_paris",
    category: 'Salutations',
    tags: ['salutations', 'groupe']
  },
  
  {
    original: "Nazali malamu, natondi yo",
    french: "Je vais bien, merci",
    english: "I'm fine, thank you",
    words: ["Nazali", "malamu", ",", "natondi", "yo"],
    audio: "Li-Nazali_malamu_natondi_yo",
    category: 'Salutations',
    tags: ['état', 'remerciement']
  },
  
  {
    original: "Mokolo ya lelo ezali kitoko",
    french: "Cette journée est belle",
    english: "Today is a beautiful day",
    words: ["Mokolo", "ya", "lelo", "ezali", "kitoko"],
    audio: "Li-Mokolo_ya_lelo_ezali_kitoko",
    category: 'Salutations',
    tags: ['temps', 'appréciation']
  },
  
  {
    original: "Nalingi koyoka sango na yo",
    french: "J'aimerais entendre tes nouvelles",
    english: "I would love to hear your news",
    words: ["Nalingi", "koyoka", "sango", "na", "yo"],
    audio: "Li-Nalingi_koyoka_sango_na_yo",
    category: 'Salutations',
    tags: ['intérêt', 'nouvelles']
  },
  
  {
    original: "Tomonana na pokwa ya lelo",
    french: "On se voit ce soir",
    english: "See you tonight",
    words: ["Tomonana", "na", "pokwa", "ya", "lelo"],
    audio: "Li-Tomonana_na_pokwa_ya_lelo",
    category: 'Salutations',
    tags: ['rendez-vous', 'temps']
  },
  
  {
    original: "Bosepela mingi na mokolo malamu",
    french: "Réjouissez-vous en cette belle journée",
    english: "Rejoice greatly on this beautiful day",
    words: ["Bosepela", "mingi", "na", "mokolo", "malamu"],
    audio: "Li-Bosepela_mingi_na_mokolo_malamu",
    category: 'Salutations',
    tags: ['souhait', 'joie']
  },

  // ==========================================
  // PRÉSENTATION - PHRASES STRUCTURÉES
  // ==========================================
  
  {
    original: "Kombo na ngai ezali Pierre",
    french: "Mon nom est Pierre",
    english: "My name is Pierre",
    words: ["Kombo", "na", "ngai", "ezali", "Pierre"],
    audio: "Li-Kombo_na_ngai_ezali_pierre",
    category: 'Présentation',
    tags: ['identité', 'nom']
  },
  
  {
    original: "Nasalaka mosala na banque",
    french: "Je travaille à la banque",
    english: "I work at the bank",
    words: ["Nasalaka", "mosala", "na", "banque"],
    audio: "Li-Nasalaka_mosala_na_banque",
    category: 'Présentation',
    tags: ['travail', 'lieu']
  },
  
  {
    original: "Nazali moto ya Kinshasa",
    french: "Je suis de Kinshasa",
    english: "I am from Kinshasa",
    words: ["Nazali", "moto", "ya", "Kinshasa"],
    audio: "Li-Nazali_moto_ya_kinshasa",
    category: 'Présentation',
    tags: ['origine', 'ville']
  },
  
  {
    original: "Nalobaka lingala na franséza",
    french: "Je parle lingala et français",
    english: "I speak Lingala and French",
    words: ["Nalobaka", "lingala", "na", "franséza"],
    audio: "Li-Nalobaka_lingala_na_franseza",
    category: 'Présentation',
    tags: ['langues', 'compétence']
  },
  
  {
    original: "Mbula na ngai ezali tuku mitano",
    french: "J'ai cinquante ans",
    english: "I am fifty years old",
    words: ["Mbula", "na", "ngai", "ezali", "tuku", "mitano"],
    audio: "Li-Mbula_na_ngai_ezali_tuku_mitano",
    category: 'Présentation',
    tags: ['âge', 'nombre']
  },
  
  {
    original: "Nalingi kolakisa yo ndako na ngai",
    french: "J'aimerais te montrer ma maison",
    english: "I would love to show you my house",
    words: ["Nalingi", "kolakisa", "yo", "ndako", "na", "ngai"],
    audio: "Li-Nalingi_kolakisa_yo_ndako_na_ngai",
    category: 'Présentation',
    tags: ['invitation', 'domicile']
  },
  
  {
    original: "Libota na ngai ezali na bato mingi",
    french: "Ma famille est nombreuse",
    english: "My family is large",
    words: ["Libota", "na", "ngai", "ezali", "na", "bato", "mingi"],
    audio: "Li-Libota_na_ngai_ezali_na_bato_mingi",
    category: 'Présentation',
    tags: ['famille', 'quantité']
  },

  // ==========================================
  // VIE QUOTIDIENNE - PHRASES COMPLÈTES
  // ==========================================
  
  {
    original: "Nalamukaka na ngonga ya libwa",
    french: "Je me réveille le matin",
    english: "I wake up in the morning",
    words: ["Nalamukaka", "na", "ngonga", "ya", "libwa"],
    audio: "Li-Nalamukaka_na_ngonga_ya_libwa",
    category: 'Vie quotidienne',
    tags: ['routine', 'temps']
  },
  
  {
    original: "Nakoliaka ndunda na mbuma",
    french: "Je mange des légumes et des fruits",
    english: "I eat vegetables and fruits",
    words: ["Nakoliaka", "ndunda", "na", "mbuma"],
    audio: "Li-Nakoliaka_ndunda_na_mbuma",
    category: 'Vie quotidienne',
    tags: ['nourriture', 'santé']
  },
  
  {
    original: "Namelaka mayi mingi na mokolo",
    french: "Je bois beaucoup d'eau par jour",
    english: "I drink a lot of water every day",
    words: ["Namelaka", "mayi", "mingi", "na", "mokolo"],
    audio: "Li-Namelaka_mayi_mingi_na_mokolo",
    category: 'Vie quotidienne',
    tags: ['hydratation', 'santé']
  },
  
  {
    original: "Nasalaka mosala na ndako",
    french: "Je fais le travail à la maison",
    english: "I do housework at home",
    words: ["Nasalaka", "mosala", "na", "ndako"],
    audio: "Li-Nasalaka_mosala_na_ndako",
    category: 'Vie quotidienne',
    tags: ['ménage', 'responsabilité']
  },

   {
    original: "Oyo nini ?",
    french: "Qu'est-ce que c'est ? ",
    english: "What is this?",
    words: ["Oyo", "nini","?"],
    audio: "Li-Oyo_nini",
    category: 'Vie quotidienne',
    tags: ['ménage', 'responsabilité']
  },
  
  {
    original: "Nasukolaka bilamba na mpokwa",
    french: "Je lave les vêtements le soir",
    english: "I wash clothes in the evening",
    words: ["Nasukolaka", "bilamba", "na", "mpokwa"],
    audio: "Li-Nasukolaka_bilamba_na_mpokwa",
    category: 'Vie quotidienne',
    tags: ['ménage', 'temps']
  },
  
  {
    original: "Natambolaka na nzela mingi",
    french: "Je marche beaucoup sur les routes",
    english: "I walk a lot on the roads",
    words: ["Natambolaka", "na", "nzela", "mingi"],
    audio: "Li-Natambolaka_na_nzela_mingi",
    category: 'Vie quotidienne',
    tags: ['exercice', 'déplacement']
  },
  
  {
    original: "Nakolalaka na ngonga ya zomi",
    french: "Je dors à dix heures",
    english: "I sleep at ten o'clock",
    words: ["Nakolalaka", "na", "ngonga", "ya", "zomi"],
    audio: "Li-Nakolalaka_na_ngonga_ya_zomi",
    category: 'Vie quotidienne',
    tags: ['sommeil', 'horaire']
  },

  {
    original: "Alingaka kolia",
    french: "Elle aime manger",
    english: "She likes to eat",
    words: ["Alingaka", "kolia"],
    audio: "Li-Alingaka_kolia",
    category: 'Vie quotidienne',
    tags: ['routine', 'temps']
  },

  // ==========================================
  // AU MARCHÉ - PHRASES TRANSACTIONNELLES
  // ==========================================
  
  {
    original: "Nalingi kosomba ndunda kitoko",
    french: "Je veux acheter de beaux légumes",
    english: "I want to buy nice vegetables",
    words: ["Nalingi", "kosomba", "ndunda", "kitoko"],
    audio: "Li-Nalingi_kosomba_ndunda_kitoko",
    category: 'Au marché',
    tags: ['achat', 'qualité']
  },
  
  {
    original: "Moteki akolakisa biloko na ye",
    french: "Le vendeur montre ses marchandises",
    english: "The seller shows his goods",
    words: ["Moteki", "akolakisa", "biloko", "na", "ye"],
    audio: "Li-Moteki_akolakisa_biloko_na_ye",
    category: 'Au marché',
    tags: ['commerce', 'présentation']
  },
  
  {
    original: "Nazali koluka mbuma ya nsafu",
    french: "Je cherche des mangues fraîches",
    english: "I am looking for fresh mangoes",
    words: ["Nazali", "koluka", "mbuma", "ya", "nsafu"],
    audio: "Li-Nazali_koluka_mbuma_ya_nsafu",
    category: 'Au marché',
    tags: ['recherche', 'fruits']
  },
  
  {
    original: "Mwasi akokataka ntalo na ngai",
    french: "La dame négocie le prix avec moi",
    english: "The lady negotiates the price with me",
    words: ["Mwasi", "akokataka", "ntalo", "na", "ngai"],
    audio: "Li-Mwasi_akokataka_ntalo_na_ngai",
    category: 'Au marché',
    tags: ['négociation', 'prix']
  },
  
  {
    original: "Napesaka mbongo na moteki",
    french: "Je donne l'argent au vendeur",
    english: "I give the money to the seller",
    words: ["Napesaka", "mbongo", "na", "moteki"],
    audio: "Li-Napesaka_mbongo_na_moteki",
    category: 'Au marché',
    tags: ['paiement', 'transaction']
  },
  
  {
    original: "Bato bazali kosomba bilei",
    french: "Les gens achètent de la nourriture",
    english: "People are buying food",
    words: ["Bato", "bazali", "kosomba", "bilei"],
    audio: "Li-Bato_bazali_kosomba_bilei",
    category: 'Au marché',
    tags: ['commerce', 'communauté']
  },
  
  {
    original: "Wenze ezali na bato mingi",
    french: "Le marché est plein de monde",
    english: "The market is full of people",
    words: ["Wenze", "ezali", "na", "bato", "mingi"],
    audio: "Li-Wenze_ezali_na_bato_mingi",
    category: 'Au marché',
    tags: ['lieu', 'affluence']
  },

  // ==========================================
  // VOYAGES - PHRASES DE DÉPLACEMENT
  // ==========================================
  
  {
    original: "Nakei na Brazzaville na motuka",
    french: "Je vais à Brazzaville en voiture",
    english: "I am going to Brazzaville by car",
    words: ["Nakei", "na", "Brazzaville", "na", "motuka"],
    audio: "Li-Nakei_na_brazzaville_na_motuka",
    category: 'Voyages',
    tags: ['destination', 'transport']
  },

   {
    original: "Tokeyi Paris mpo na kotanga",
    french: "Nous sommes partis à Paris pour étudier",
    english: "We went to Paris to study",
    words: ["Tokeyi", "na", "Paris", "mpo", "kotanga"],
    audio: "Li-Tokeyi_paris_mpo_na_kotanga",
    category: 'Voyages',
    tags: ['destination', 'transport']
  },

   {
    original: "Nalonga mboka na nga na mawa",
    french: "J'ai quitté mon pays avec tristesse",
    english: "I left my country with sadness",
    words: ["Nalonga", "mboka", "na", "nga", "na","mawa"],
    audio: "Li-Nakei_na_brazzaville_na_motuka",
    category: 'Voyages',
    tags: ['destination', 'transport']
  },

 
  
  {
    original: "Motambolisi akolakisa nzela",
    french: "Le guide montre le chemin",
    english: "The guide shows the way",
    words: ["Motambolisi", "akolakisa", "nzela"],
    audio: "Li-Motambolisi_akolakisa_nzela",
    category: 'Voyages',
    tags: ['guidance', 'direction']
  },
  
  {
    original: "Nalingi kokota na mpenza",
    french: "Je veux entrer dans l'avion",
    english: "I want to board the plane",
    words: ["Nalingi", "kokota", "na", "mpenza"],
    audio: "Li-Nalingi_kokota_na_mpenza",
    category: 'Voyages',
    tags: ['transport', 'aviation']
  },
  
  {
    original: "Bapasajè bazali kozela motuka",
    french: "Les passagers attendent le véhicule",
    english: "The passengers are waiting for the vehicle",
    words: ["Bapasajè", "bazali", "kozela", "motuka"],
    category: 'Voyages',
    tags: ['attente', 'transport']
  },
  
  {
    original: "Mokambi akoloba na mikolo",
    french: "Le capitaine parle aux passagers",
    english: "The captain speaks to the passengers",
    words: ["Mokambi", "akoloba", "na", "mikolo"],
    audio: "Li-Mokambi_akoloba_na_mikolo",
    category: 'Voyages',
    tags: ['communication', 'autorité']
  },
  
  {
    original: "Nazali kotala bisika ya kitoko",
    french: "Je regarde de beaux paysages",
    english: "I am looking at beautiful landscapes",
    words: ["Nazali", "kotala", "bisika", "ya", "kitoko"],
    audio: "Li-Nazali_kotala_bisika_ya_kitoko",
    category: 'Voyages',
    tags: ['observation', 'beauté']
  },
  
  {
    original: "Mobembo mokomisi nga na ndako",
    french: "Le voyage me ramène à la maison",
    english: "The journey brings me back home",
    words: ["Mobembo", "mokomisi", "nga", "na", "ndako"],
    audio: "Li-Mobembo_mokomisi_nga_na_ndako",
    category: 'Voyages',
    tags: ['retour', 'domicile']
  },

  // ==========================================
  // FAMILLE ET RELATIONS - PHRASES FAMILIALES
  // ==========================================
  
  {
    original: "Mama na ngai akolamisa bilei",
    french: "Ma mère prépare la nourriture",
    english: "My mother prepares the food",
    words: ["Mama", "na", "ngai", "akolamisa", "bilei"],
    audio: "Li-Mama_na_ngai_akolamisa_bilei",
    category: 'Famille et relations',
    tags: ['famille', 'cuisine']
  },
  
  {
    original: "Tata azali kotanga gazeti",
    french: "Papa lit le journal",
    english: "Dad is reading the newspaper",
    words: ["Tata", "azali", "kotanga", "gazeti"],
    audio: "Li-Tata_azali_kotanga_gazeti",
    category: 'Famille et relations',
    tags: ['famille', 'lecture']
  },
  
  {
    original: "Bana bazali kosakana na libanda",
    french: "Les enfants jouent dehors",
    english: "The children are playing outside",
    words: ["Bana", "bazali", "kosakana", "na", "libanda"],
    audio: "Li-Bana_bazali_kosakana_na_libanda",
    category: 'Famille et relations',
    tags: ['enfance', 'jeu']
  },
  
  {
    original: "Koko akoloba masolo ya kala",
    french: "Grand-mère raconte des histoires d'autrefois",
    english: "Grandmother tells stories from the past",
    words: ["Koko", "akoloba", "masolo", "ya", "kala"],
    audio: "Li-Koko_akoloba_masolo_ya_kala",
    category: 'Famille et relations',
    tags: ['tradition', 'récit']
  },
  
  {
    original: "Ndeko na ngai azali kosala devoirs",
    french: "Mon frère fait ses devoirs",
    english: "My brother is doing his homework",
    words: ["Ndeko", "na", "ngai", "azali", "kosala", "devoirs"],
    audio: "Li-Ndeko_na_ngai_azali_kosala_devoirs",
    category: 'Famille et relations',
    tags: ['éducation', 'fratrie']
  },
  
  {
    original: "Libota mobimba ezali kosangana",
    french: "Toute la famille se réunit",
    english: "The whole family gathers together",
    words: ["Libota", "mobimba", "ezali", "kosangana"],
    audio: "Li-Libota_mobimba_ezali_kosangana",
    category: 'Famille et relations',
    tags: ['réunion', 'unité']
  },
  
  {
    original: "Balingi baninga bazali koya",
    french: "Mes amis chers viennent",
    english: "My dear friends are coming",
    words: ["Balingi", "baninga", "bazali", "koya"],
    audio: "Li-Balingi_baninga_bazali_koya",
    category: 'Famille et relations',
    tags: ['amitié', 'visite']
  },

  // ==========================================
  // URGENCES ET SANTÉ - PHRASES MÉDICALES
  // ==========================================
  
  {
    original: "Monganga azali kotala mokono na ngai",
    french: "Le médecin examine ma jambe",
    english: "The doctor is examining my leg",
    words: ["Monganga", "azali", "kotala", "mokono", "na", "ngai"],
    category: 'Urgences et santé',
    tags: ['médical', 'examen']
  },
  
  {
    original: "Nazali na mpasi ya motó makasi",
    french: "J'ai un fort mal de tête",
    english: "I have a bad headache",
    words: ["Nazali", "na", "mpasi", "ya", "motó", "makasi"],
    category: 'Urgences et santé',
    tags: ['douleur', 'symptôme']
  },
  
  {
    original: "Muasi azali kopesa nkisi",
    french: "L'infirmière donne le médicament",
    english: "The nurse is giving the medicine",
    words: ["Muasi", "azali", "kopesa", "nkisi"],
    category: 'Urgences et santé',
    tags: ['soins', 'traitement']
  },
  
  {
    original: "Baleki bazali kokamataka motuka ya mbalaka",
    french: "Les urgentistes prennent l'ambulance",
    english: "The paramedics are taking the ambulance",
    words: ["Baleki", "bazali", "kokamataka", "motuka", "ya", "mbalaka"],
    category: 'Urgences et santé',
    tags: ['urgence', 'transport']
  },
  
  {
    original: "Nakozonga na lopitalo lobi",
    french: "Je retournerai à l'hôpital demain",
    english: "I will go back to the hospital tomorrow",
    words: ["Nakozonga", "na", "lopitalo", "lobi"],
    category: 'Urgences et santé',
    tags: ['rendez-vous', 'suivi']
  },
  
  {
    original: "Mobele akokata na mbeli",
    french: "Le malade guérit avec le temps",
    english: "The patient heals with time",
    words: ["Mobele", "akokata", "na", "mbeli"],
    category: 'Urgences et santé',
    tags: ['guérison', 'temps']
  },
  
  {
    original: "Tosengeli kolingaka nzoto na biso",
    french: "Nous devons prendre soin de notre corps",
    english: "We must take care of our bodies",
    words: ["Tosengeli", "kolingaka", "nzoto", "na", "biso"],
    category: 'Urgences et santé',
    tags: ['prévention', 'conseil']
  },

  // ==========================================
  // LOISIRS ET CULTURE - PHRASES RÉCRÉATIVES
  // ==========================================
  
  {
    original: "Nabetaka mbonda na baninga na ngai",
    french: "Je joue au football avec mes amis",
    english: "I play football with my friends",
    words: ["Nabetaka", "mbonda", "na", "baninga", "na", "ngai"],
    category: 'Loisirs et culture',
    tags: ['sport', 'amitié']
  },
  
  {
    original: "Moyembi azali koyemba nzembo kitoko",
    french: "Le chanteur chante une belle chanson",
    english: "The singer is singing a beautiful song",
    words: ["Moyembi", "azali", "koyemba", "nzembo", "kitoko"],
    category: 'Loisirs et culture',
    tags: ['musique', 'performance']
  },
  
  {
    original: "Bato bazali kobina na rythme",
    french: "Les gens dansent en rythme",
    english: "People are dancing to the rhythm",
    words: ["Bato", "bazali", "kobina", "na", "rythme"],
    category: 'Loisirs et culture',
    tags: ['danse', 'musique']
  },
  
  {
    original: "Nalingi kotanga mikanda ya masolo",
    french: "J'aime lire des livres d'histoires",
    english: "I like reading storybooks",
    words: ["Nalingi", "kotanga", "mikanda", "ya", "masolo"],
    category: 'Loisirs et culture',
    tags: ['lecture', 'récit']
  },


  
  {
    original: "Batali bazali kosala masano na cinéma",
    french: "Les acteurs font un spectacle au cinéma",
    english: "The actors are putting on a show at the cinema",
    words: ["Batali", "bazali", "kosala", "masano", "na", "cinéma"],
    category: 'Loisirs et culture',
    tags: ['théâtre', 'divertissement']
  },
  
  {
    original: "Nakende na fête ya libala",
    french: "Je vais à une fête de mariage",
    english: "I am going to a wedding party",
    words: ["Nakende", "na", "fête", "ya", "libala"],
    category: 'Loisirs et culture',
    tags: ['célébration', 'tradition']
  },

   {
    original: "Alingaka kokende na ba musées",
    french: "Elle aime aller dans les musées",
    english: "She likes going to museums",
    words: ["Alingaka", "kokende", "na", "ba", "musées"],
    category: 'Loisirs et culture',
    tags: ['célébration', 'tradition']
  },

  {
    original: "Ba congolais balingaka kobina koseka na koyemba mingi",
    french: "Les congolais aiment beaucoup danser rire et chanter",
    english: "Congolese people love dancing, laughing, and singing a lot",
    words: ["Ba", "congolais", "balingaka", "kobina", "koseka","na","koyemba","mingi"],
    category: 'Loisirs et culture',
    tags: ['célébration', 'tradition']
  },
  
  {
    original: "Basali bazali kopesa concert na ziko",
    french: "Les musiciens donnent un concert ce soir",
    english: "The musicians are giving a concert tonight",
    words: ["Basali", "bazali", "kopesa", "concert", "na", "ziko"],
    category: 'Loisirs et culture',
    tags: ['musique', 'événement']
  },
   {
    original: "Nalingi kobina",
    french: "J'aime danser",
    english: "I like dancing",
    words: ["Nalingi", "kobina"],
    category: 'Loisirs et culture',
    tags: ['musique', 'événement']
  },


   

  // ==========================================
  // PHRASES COMPLEXES SUPPLÉMENTAIRES
  // ==========================================

  // Expressions de temps et durée
  {
    original: "Nakosalaka mosala longwa na ngonga ya libwa tii na mpokwa",
    french: "Je travaille du matin jusqu'au soir",
    english: "I work from morning until evening",
    words: ["Nakosalaka", "mosala", "longwa", "na", "ngonga", "ya", "libwa", "tii", "na", "mpokwa"],
    audio: "Li-Nakosalaka_mosala_longwa_na_ngonga_ya_libwa_tii_na_mpokwa",
    category: 'Vie quotidienne',
    tags: ['travail', 'durée', 'routine']
  },

  // Expressions de cause et conséquence
  {
    original: "Nazali kosepela mpenza soki namonaki yo",
    french: "Je suis très heureux quand je te vois",
    english: "I am very happy when I see you",
    words: ["Nazali", "kosepela", "mpenza", "soki", "namonaki", "yo"],
    audio: "Li-Nazali_kosepela_mpenza_soki_namonaki_yo",
    category: 'Famille et relations',
    tags: ['émotion', 'condition', 'joie']
  },

  // Expressions de comparaison
  {
    original: "Mwana oyo aleki bandeko na ye na malangá",
    french: "Cet enfant est plus intelligent que ses frères",
    english: "This child is smarter than his siblings",
    words: ["Mwana", "oyo", "aleki", "bandeko", "na", "ye", "na", "malangá"],
    audio: "Li-Mwana_oyo_aleki_bandeko_na_ye_na_malanga",
    category: 'Famille et relations',
    tags: ['comparaison', 'intelligence', 'enfants']
  },

  // Expressions de possession étendue
  {
    original: "Motuka ya mobali na ngai ezali na langi ya motane",
    french: "La voiture de mon mari est de couleur rouge",
    english: "My husband's car is red",
    words: ["Motuka", "ya", "mobali", "na", "ngai", "ezali", "na", "langi", "ya", "motane"],
    audio: "Li-Motuka_ya_mobali_na_ngai_ezali_na_langi_ya_motane",
    category: 'Famille et relations',
    tags: ['possession', 'description', 'couleur']
  },

  // Expressions d'opinion et de sentiment
  {
    original: "Nakanisi ete mokolo ya lobi ekozala malamu",
    french: "Je pense que demain sera une bonne journée",
    english: "I think tomorrow will be a good day",
    words: ["Nakanisi", "ete", "mokolo", "ya", "lobi", "ekozala", "malamu"],
    audio: "Li-Nakanisi_ete_mokolo_ya_lobi_ekozala_malamu",
    category: 'Vie quotidienne',
    tags: ['opinion', 'futur', 'espoir']
  },

  // Expressions d'action réciproque
  {
    original: "Bana bazali kosunga bango na bango na misala",
    french: "Les enfants s'entraident dans les travaux",
    english: "The children help each other with chores",
    words: ["Bana", "bazali", "kosunga", "bango", "na", "bango", "na", "misala"],
    audio: "Li-Bana_bazali_kosunga_bango_na_bango_na_misala",
    category: 'Famille et relations',
    tags: ['entraide', 'coopération', 'travail']
  }
];

// Fonctions utilitaires
export const getSentencesByCategory = (category: keyof typeof SENTENCE_CATEGORIES) =>
  sentencesToConstruct.filter(sentence => sentence.category === category);

export const getSentencesByTags = (tags: string[]) =>
  sentencesToConstruct.filter(sentence => 
    tags.some(tag => sentence.tags.includes(tag))
  );

export const getCategories = () => SENTENCE_CATEGORIES;

export default sentencesToConstruct;
